import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { type SiteEntity } from '@/libs/api'

import { type FetchSitesByDcIdQuery } from '../api'
import { getSitesByDcIdSelectQueryOptions } from '../query-options'

/**
 * Select用のDCに紐づく地点一覧のUseQuery
 *
 * 地点マスタは頻繁に変わらず、更新時は invalidateQueries で明示的に無効化されるため、
 * 長めの staleTime を設定してマウントごとの再取得（矢羽根ホバー等）を抑える。
 * DC 全件を返す重いエンドポイントなので、再取得抑制の効果が大きい。
 */
export const useSitesByDcIdSelectQuery = (
  query: FetchSitesByDcIdQuery,
  options?: {
    disabled: boolean
  }
): UseQueryResult<SiteEntity[]> => {
  const disabled = options?.disabled ?? false
  return useQuery<SiteEntity[]>({
    ...getSitesByDcIdSelectQueryOptions(query),
    enabled: !disabled,
    retry: false,
    staleTime: 10 * 60 * 1000
  })
}
